<div class="container mx-auto max-w-640 pb-5">
  <ul
    class="flex mt-6 justify-center"
    [style.color]="textColor | contentBuilderColor: 'primary-800'"
  >
    @if (facebookUrl) {
      <li class="mx-4 text-2xl">
        <a
          [href]="facebookUrl"
          target="_blank"
        >
          <i
            class="icon icon-facebook text-3xl w-7.5 h-7.5"
            [style.color]="textColor | contentBuilderColor: 'primary-800'"
          ></i>
        </a>
      </li>
    }

    @if (twitterUrl) {
      <li class="mx-4 text-2xl">
        <a
          [href]="twitterUrl"
          target="_blank"
        >
          <i
            class="icon icon-x text-3xl w-7.5 h-7.5"
            [style.color]="textColor | contentBuilderColor: 'primary-800'"
          ></i>
        </a>
      </li>
    }
    @if (instagramUrl) {
      <li class="mx-4 text-2xl">
        <a
          [href]="instagramUrl"
          target="_blank"
        >
          <i
            class="icon icon-instagram text-3xl w-7.5 h-7.5"
            [style.color]="textColor | contentBuilderColor: 'primary-800'"
          ></i>
        </a>
      </li>
    }
    @if (linkedinUrl) {
      <li class="mx-4 text-2xl">
        <a
          [href]="linkedinUrl"
          target="_blank"
        >
          <i
            class="icon icon-linkedin text-3xl w-7.5 h-7.5"
            [style.color]="textColor | contentBuilderColor: 'primary-800'"
          ></i>
        </a>
      </li>
    }
    @if (tiktokUrl) {
      <li class="mx-4 text-2xl">
        <a
          [href]="tiktokUrl"
          target="_blank"
        >
          <i
            class="icon icon-tiktok text-3xl w-7.5 h-7.5"
            [style.color]="textColor | contentBuilderColor: 'primary-800'"
          ></i>
        </a>
      </li>
    }
    @if (googleUrl) {
      <li class="mx-4 text-2xl">
        <a
          [href]="googleUrl"
          target="_blank"
        >
          <i
            class="icon icon-google text-3xl w-7.5 h-7.5"
            [style.color]="textColor | contentBuilderColor: 'primary-800'"
          ></i>
        </a>
      </li>
    }
  </ul>
</div>
